import Qs from 'qs';
import axios from 'axios';
import {INTERFACE_GATEWAY_URL} from 'src/config/params-local';
import {getUserIdentity, logging} from 'src/components/api/interface-hhy';

/**
 * 创建axios实例
 * @return {axios}
 */
export function createHttp() {
  let $http = axios.create({
    baseURL: INTERFACE_GATEWAY_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    transformRequest: [function (data) {
      return Qs.stringify(data);
    }],
    timeout: 30000
  });

// 添加一个响应拦截器
  $http.interceptors.response.use(res => {
    if (res.data.code && res.data.code === -1) {
      logging({ request: res.config, responseData: res.data });
      let errMsg = {response: {data: {message: res.data.msg ? res.data.msg : ''}}};
      return Promise.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, err => {
    let responseData = err.response ? err.response.data : null;
    logging({
      request: err.config,
      responseData,
      err: responseData ? null : err
    });
    return Promise.reject(err);
  });
  return $http;
}

/**
 * 获取JSSDK签名
 * POST /wechat/msg/jssdk/sign
 */
export function weChatJsSdkSign (params) {
  let url = '/wechat/msg/jssdk/sign';
  let {clientUrl, stamp, nonce} = params;
  return createHttp().post(url, {
    url: clientUrl,
    stamp,
    nonce,
    appid: getUserIdentity('appId')
  });
}



// WEBPACK FOOTER //
// ./src/components/api/interface-gateway.js